var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { OnDestroy, OnInit } from '@angular/core';
import { APP_DATE_FORMATS } from '../../../_pipes/angular2-material-datepicker-custom-date';
import { PlanningService } from '../../../_services/planning.service';
import { MatDialog } from '@angular/material';
import { addDays, eachDayOfInterval, endOfWeek, format, isSameDay, parseISO, startOfWeek } from 'date-fns';
import { nl } from 'date-fns/locale';
import { ModalPlanningViewComponent } from './modal-planning-view/modal-planning-view.component';
var ɵ0 = APP_DATE_FORMATS;
var PlanningListComponent = /** @class */ (function () {
    function PlanningListComponent(planningService, dialogService) {
        this.planningService = planningService;
        this.dialogService = dialogService;
        this.view = 'week';
        this.currentDate = new Date();
        this.days = [];
        this.events = [];
        this.eventsMap = {};
    }
    PlanningListComponent.prototype.ngOnInit = function () {
        this.getPlanning();
    };
    PlanningListComponent.prototype.ngOnDestroy = function () {
    };
    PlanningListComponent.prototype.buildEventsMap = function () {
        var e_1, _a, e_2, _b;
        this.eventsMap = {};
        try {
            for (var _c = __values(this.events), _d = _c.next(); !_d.done; _d = _c.next()) {
                var event_1 = _d.value;
                var start = new Date(event_1.start_at);
                var end = new Date(event_1.end_at || event_1.start_at); // fallback if end missing
                if (end < start) {
                    end = start; // make end same as start if end comes before start
                }
                var days = eachDayOfInterval({ start: start, end: end });
                try {
                    for (var days_1 = __values(days), days_1_1 = days_1.next(); !days_1_1.done; days_1_1 = days_1.next()) {
                        var day = days_1_1.value;
                        var key = format(day, 'yyyy-MM-dd');
                        if (!this.eventsMap[key]) {
                            this.eventsMap[key] = [];
                        }
                        this.eventsMap[key].push(event_1);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (days_1_1 && !days_1_1.done && (_b = days_1.return)) _b.call(days_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.generateWeek();
    };
    PlanningListComponent.prototype.getEventsForDay = function (date) {
        return this.eventsMap[format(date, 'yyyy-MM-dd')] || [];
    };
    PlanningListComponent.prototype.hasEvents = function (date) {
        return this.getEventsForDay(date).length > 0;
    };
    PlanningListComponent.prototype.changeWeek = function (amount) {
        this.currentDate = addDays(this.currentDate, amount * 7);
        this.getPlanning();
    };
    PlanningListComponent.prototype.generateWeek = function () {
        var start = startOfWeek(this.currentDate, { weekStartsOn: 1 });
        this.days = [];
        for (var i = 0; i < 7; i++) {
            this.days.push(addDays(start, i));
        }
    };
    PlanningListComponent.prototype.getWeekRange = function (date) {
        var start = startOfWeek(date, { weekStartsOn: 1 });
        var end = endOfWeek(date, { weekStartsOn: 1 });
        var startFormatted = format(start, 'd. MMM', { locale: nl });
        var endFormatted = format(end, 'd. MMM yy', { locale: nl });
        return startFormatted + " \u2013 " + endFormatted;
    };
    PlanningListComponent.prototype.getDayFormat = function (date) {
        var formatted = format(date, 'EEEE, d MMMM yyyy', { locale: nl });
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    };
    PlanningListComponent.prototype.startAndEndNotInSameDay = function (event) {
        return !isSameDay(parseISO(event.start_at), parseISO(event.end_at));
    };
    PlanningListComponent.prototype.viewEvent = function (event) {
        this.dialogService.open(ModalPlanningViewComponent, {
            data: event
        });
    };
    PlanningListComponent.prototype.getPlanning = function () {
        var _this = this;
        this.planningService.getPlannings({
            start: format(startOfWeek(this.currentDate, { weekStartsOn: 1 }), 'yyyy-MM-dd'),
        }).then(function (data) {
            if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
                _this.events = data.data.map(function (e) { return (__assign({}, e, { date: new Date(e.start_at) })); });
            }
            _this.buildEventsMap();
        });
    };
    return PlanningListComponent;
}());
export { PlanningListComponent };
export { ɵ0 };
